import React, { FC, useContext } from 'react';
import { WithStyle } from '../../utils/with-style';
import ModalContext from './modal-context';
import { ModalHeaderStyled, ModalClose } from './modal.styled';
import { ModalHeaderProps } from './types';
import IconClose from '../icon/icons/close';

const ModalHeader: FC<ModalHeaderProps> & WithStyle = ({ children, hideClose, ...rest }) => {
  const contextProps = useContext(ModalContext);
  return (
    <ModalHeaderStyled {...contextProps} {...rest}>
      {children}
      {!hideClose && (
        <ModalClose onClick={contextProps.onClose}>
          <IconClose $color="grayDarker" $size={18} />
        </ModalClose>
      )}
    </ModalHeaderStyled>
  );
};

export default ModalHeader;
